import React from "react"

const CardHeader = ({ heading, hideHeaderBlueLine = false, style, textClassName = 'textLG w-700' }) => {
    return <div className="d-flex align-items-center" style={{ alignItems: "center", gap: "0.6rem", flex: 1, ...style }}>
        {(!hideHeaderBlueLine && window.innerWidth > 760) && <div type='vertical' style={{ width: "0.3rem", height: "2rem", backgroundColor: "var(--primary)", borderRadius: "4px" }} />}
        <span className={`${textClassName} black d-flex align-items-center`} >{heading}</span>
    </div>
}

export { CardHeader }